import React, { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../AuthContext';

export default function Navbar() {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav className="navbar">
      <Link to="/" className="nav-logo">Billing</Link>
      {user ? (
        <div className="nav-right">
          <span className="nav-user">Hi, {user.username} ({user.role})</span>
          <button onClick={handleLogout} className="btn-logout">Logout</button>
        </div>
      ) : (
        <Link to="/login" className="nav-login">Login</Link>
      )}
    </nav>
  );
}
